/* eslint-disable react/function-component-definition */
import { isPrint } from '@/utils/print'
import React from 'react'
import tw from 'twin.macro'

export interface Props {
  children: React.ReactNode
  /** comparison style - if true fixes first column on small screens */
  comparisonTable?: boolean
  /** narrow or wide */
  contentWidth?: string
  /** white or gray */
  tableColor?: string
  /** table has a footer */
  tableHasFooter?: boolean
}

const whiteTable = tw`[td]:border-gray-100 [td:after]:bg-gray-100 [th]:border-gray-100 bg-white`
const grayTable = tw`[td]:border-gray-200 [td:after]:bg-gray-200 bg-gray-100 [th]:border-gray-200`
const tdXPaddingWide = tw`[th]:px-4 lg:[th]:!px-10 [td]:px-4 lg:[td]:!px-10 [td:after]:(left-3 right-3) lg:[td:after]:(left-6 right-6)`
const tdXPaddingNarrow = tw`[th]:px-4 [td]:px-4 [td:after]:left-3 [td:after]:right-3`

const commonRowStyles = tw`
  relative
  text-indigoBlue 
  border-collapse 
  w-full 
  rounded-3xl
  break-normal
  [p]:break-normal
  [th:last-of-type]:border-r-0
  [th]:(leading-tight py-4 font-bold border-r text-left)
  md:[th:first-of-type]:(w-1/3)
  md:[th]:(text-lg !pt-11)
  md:[th > p]:text-lg
  [td]:(text-left leading-tight py-4 border-r)
  [td:last-of-type]:border-r-0 
  [td:after]:(h-[1px] block content absolute bottom-0 z-0)
  [tfoot td]:(pb-10 font-bold)
  [tr]:break-inside-avoid
  [tfoot td:after]:hidden
  `

const BwTable = ({ children, contentWidth, tableColor, tableHasFooter, comparisonTable }: Props) => {
  const print = isPrint()
  return (
    <table
      css={[
        tableColor === 'white' ? whiteTable : grayTable,
        contentWidth === 'wide' ? tdXPaddingWide : tdXPaddingNarrow,
        commonRowStyles,
        !tableHasFooter && tw`[tr]:last:[td]:pb-10 [tr]:last:[td:after]:hidden`,
        comparisonTable &&
          tw`
      [th]:(text-center)
      [td]:(text-center)
      [td:first-of-type]:text-left
      [th:first-of-type]:text-left
      min-w-[550px] border-separate border-spacing-0 table-fixed 
      max-md:[th]:w-[160px] 
      max-md:[tr td:first-of-type]:(sticky left-0 z-10 bg-white border-r border-gray-100 shadow-lg) 
      max-md:[tr th:first-of-type]:(rounded-tl-3xl sticky left-0 z-10 bg-white border-r border-gray-100 shadow-lg)
      `,
        print && tw`[p]:break-all`,
      ]}
    >
      {children}
    </table>
  )
}

export default BwTable
